import { browseAndLoadBinary } from "../../persist/browseAndLoad";

/** use to base64 encode the files used by mespeak-core.js */
export function EncodeCore() {
  function onLoadBinary(filename: string, contents: Uint8Array) {
    // unclear why it doesn't know about toBase64, but upgrading Typescript might fix this
    const base64 = (contents as unknown as Hack).toBase64();
    const result = `"${filename}": "${base64}",`;
    console.log(result);

    /*
    const backagain = window.atob(base64);
    console.log(`input len: ${contents.length}`);
    console.log(`output len: ${backagain.length}`);
    console.log(`base64 len: ${base64.length}`)
    */
  }

  return (<>
    <button onClick={() => browseAndLoadBinary(onLoadBinary)}>encode mespeak-core.js</button>
    &nbsp;
    phontab, phonindex, phondata
  </>);
}

interface Hack {
  toBase64(): string;
}
